import ClassifyNav from '~/pages/ClassifyDocumentsV2/ClassifyNav';
import { CATEGORY_IDS } from '~/pages/Home/constants';

import useRailRouteMatches from '../../Rail/hooks/useRailRouteMatches';
import WorkNavAlertItems from './NavAlertItems/WorkNavAlertItems';

type SelectedLeftDrawerContentProps = {
  selectedCategory?: number;
};

const SelectedLeftDrawerContent = ({
  selectedCategory,
}: Readonly<SelectedLeftDrawerContentProps>) => {
  const { is1003Match, isKnowYourLoanMatch } = useRailRouteMatches();

  if (selectedCategory === CATEGORY_IDS.CLASSIFY) {
    return <ClassifyNav />;
  }
  if (!is1003Match && !isKnowYourLoanMatch) {
    return <WorkNavAlertItems />;
  }
  throw new Error(
    'SelectedLeftDrawerContent: No matching content for selected category or route',
  );
};

export default SelectedLeftDrawerContent;
